
import { currencyType } from './types'
import currencyData from "../../data/currencyData.json";

export class currencyService {
  async getCurrencyList(): Promise<currencyType[]> {
    const data = currencyData.data
    return data;
  }
}